import { TReconnectConfig } from '../../types/reconnection-config';
import { URLServiceComponent } from './URLServiceComponent';

export const OAuthReconnectionConfig: TReconnectConfig = {
  serviceComponent: URLServiceComponent,
};
